import { del, get, post } from '../axios'
import { integrationToken, integrationTokenWithPlainText } from './integration-token'
import { GenerateInput } from './input/generate-input'
import { z } from 'zod'

export function fetchIntegrationTokens() {
    return get(integrationToken.array(), `/integration-tokens`)
}

export function generateIntegrationToken(input: GenerateInput) {
    return post(integrationTokenWithPlainText, `/integration-tokens`, input)
}

export function revokeIntegrationToken(tokenId: string) {
    return del(z.object({ message: z.string() }), `/integration-tokens/${tokenId}`)
}
